export default function (value) {
    let result = false
    if (value) {
        switch (value.length) {
            case 11:
                result =  value.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3')
                break
            case 9:
                result = value.replace(/^(\d{5})(\d{4}).*/, '$1-$2')
                break
            case 8:
                result = value.replace(/^(\d{4})(\d{4}).*/, '$1-$2')
                break
            case 10:
                result = value.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3')
                break
            case 13:
                result = value.replace(/^(\d{2})(\d{2})(\d{5})(\d{4}).*/, '+$1 ($2) $3-$4')
                break
            case 12:
                result = value.replace(/^(\d{2})(\d{2})(\d{4})(\d{4}).*/, '+$1 ($2) $3-$4')
                break
        }
    }
    
    return result
}